import React, { useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import './Playground.css';


const Playground = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const iframeURL = query.get('url');
  const iframeRef = useRef(null);

  const handleIframeError = (e) => {
    console.error('Error loading iframe:', e.target);
  };

  const getModifiedUrl = (url) => {
    try {
      const urlObj = new URL(url);
      urlObj.protocol = 'https:';
      return urlObj.toString();
    } catch (error) {
      console.error('Invalid URL:', error);
      return url;
    }
  };

  return (
    <div
      className="main-content"
    >
      <div className="instances-title-wrapper">
        <div className="instances-toolkit-title">
          Playground
        </div>
      </div>
      <div className="playground-wrapper">
        {iframeURL ? (
          <iframe
            ref={iframeRef}
            src={getModifiedUrl(iframeURL)}
            sandbox="allow-scripts allow-same-origin allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
            }}
            title="Environment Viewer"
            onError={handleIframeError}
          />
        ) : (
          <Box
            sx={{ textAlign: 'center', marginTop: 1, display: 'flex', flexDirection: 'Column', alignItems: 'center' }}
          >
            <Button
              variant="contained"
              onClick={() => navigate('/myapplications')}
              sx={{
                width: '120px',
                textTransform: 'none',
                borderRadius: '11.803px',
                background:
                  'linear-gradient(91deg, #00FF85 7.38%, #00E5FF 96.85%)',
                color: '#0E161B',
                textAlign: 'center',
                fontFamily: 'Plus Jakarta Sans',
                fontSize: '10.938px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '150%',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.3)',
                  color: 'black',
                },
              }}
            >
              Instances
            </Button>
          </Box>
        )}
      </div>
    </div>
  );
};

export default Playground;
